import { FC, useEffect, useState } from 'react';

import { IOtherService } from '../AdditionalServicesTab';
import { client } from '../../../../networking/client';
import WithLoader from '../../../../components/WithLoader/WithLoader';
import Modal from '../../../../components/UI/Modals/Modal';
import PrimaryButtonV2 from '../../../../components/UI/Buttons/PrimaryButtonV2';
import classes from './EditServiceModal.module.css';
import { useTranslation } from '../../../../hooks/useTranslations';
// import plusIcon from '../../../../assets/icons/plusIcon.svg';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  serviceSelected: IOtherService | null;
  onServiceEditHandler: () => void;
}

const EditServicesModal: FC<Props> = ({
  isOpen,
  onClose,
  serviceSelected,
  onServiceEditHandler,
}) => {
  const { translations } = useTranslation();
  const [remarks, setRemarks] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setRemarks(serviceSelected?.remarks ?? '');
  }, [serviceSelected]);

  const handleEditService = async () => {
    try {
      setIsLoading(true);
      await client.put(
        `/healthpoint/medical-service/${serviceSelected?.work_order_other_services_log_id}`,
        {
          remarks: remarks,
        }
      );
      onServiceEditHandler();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton={false}
      containerPadding="20px 0px 30px 30px"
      header={translations('edit.services')}
      width="85%"
      maxWidth="800px"
      headerStyles={{
        textAlign: 'center',
      }}
    >
      <div className={classes.container}>
        <div className={classes.serviceInfoContainer}>
          <div className={classes.serviceLabel}>{translations('service')}</div>
          <div className={classes.serviceName}>
            <span>#{serviceSelected?.service_id} </span>- {serviceSelected?.service_name}
          </div>
        </div>
        <div className={classes.remarksContainer}>
          <div className={classes.remarksLabel}>{translations('remarks')}</div>
          <textarea
            className={classes.remarksTextArea}
            value={remarks}
            onChange={(event) => {
              if (event.target.value.length <= 2000) setRemarks(event.target.value);
            }}
          />
          <div className={classes.remarksLength}>{remarks?.length ?? 0}/2000</div>
        </div>
        {/* <div className={classes.attachDocs}>
          <img src={plusIcon} />
          <span>Attach document</span>
        </div> */}
        <WithLoader isLoading={isLoading}>
          <PrimaryButtonV2
            disabled={false}
            text={translations('save')}
            buttonStyle={{
              marginRight: 20,
              minWidth: 200,
              height: 45,
              marginTop: 40,
            }}
            onClick={handleEditService}
          />
        </WithLoader>
      </div>
    </Modal>
  );
};

export default EditServicesModal;
